export function filterItemsByTagId(items, itemAttribute, tagId) {
  return items?.filter((item) => filterItemByTagId(item, itemAttribute, tagId));
}

export function filterItemByTagId(item, itemAttribute, tagId) {
  return (
    !tagId || item[itemAttribute]?.some((itemTag) => itemTag.tagId == tagId)
  );
}
